import {
  inject,
  InjectionToken,
  makeEnvironmentProviders
} from '@angular/core';
import { INFRASTRUCTURE_CONFIG } from '../infrastructure/infrastructure-config.token';

export const APOLLO_CACHE_CONFIG = new InjectionToken<{
  [key: string]: string;
}>('APOLLO_CACHE_CONFIG');

export function provideApolloHttpCacheConfig() {
  return makeEnvironmentProviders([
    {
      provide: APOLLO_CACHE_CONFIG,
      useFactory: () => {
        const config = inject(INFRASTRUCTURE_CONFIG);

        return config.apolloCacheIds || {};
      }
    }
  ]);
}
